const MERCHANT_ID_PREFIX = 'merchant:';

/**
 * Canonical authenticated identity for Farmart App analytics.
 *
 * The namespace prevents merchant database IDs from being confused with the
 * legacy mobile-number values already present in MoEngage and Chronolog data.
 */
export function chronologMerchantUserId(
	merchantDetailId: string | number | null | undefined,
): string | undefined {
	if (merchantDetailId == null) return undefined;
	const normalized = String(merchantDetailId).trim();
	if (!/^[1-9]\d*$/.test(normalized)) return undefined;
	return `${MERCHANT_ID_PREFIX}${normalized}`;
}
